import { useAuthStore } from '@/store/auth-store';
import { sessionScope } from '@/features/auth/session-scope';

/** Shared by realtime and queries without pulling CRUD/SDK into application startup. */
export const tagLibraryKey = () => ['tags', sessionScope(useAuthStore.getState())] as const;
